<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockCount.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockCount.pageTitle'),
            href: '/admin/stock-counts',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal ts-space-y-3">
          <div class="row">
            <label class="required col-form-label col-md-1">{{
              $t('stockCount.date')
            }}</label>
            <div class="col-md-4">
              <a-date-picker
                v-model="model.count_date"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                class="ts-w-full"
              ></a-date-picker>
              <div class="validate" v-if="errors.has('count_date')">
                {{ errors.first('count_date') }}
              </div>
            </div>
          </div>
          <div class="row ts-flex">
            <label class="required col-form-label col-md-1">{{
              $t('stockCount.totalAmount')
            }}</label>
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                v-model="model.total_amount"
                readonly
              />
            </div>
            <div class="col-md-7">
              <ts-input
                v-model.trim="search"
                :placeholder="$t('search')"
                v-tooltip="$t('stockCount.searchProduct')"
                style="width: 250px"
                class="inline-block ts-float-right"
              />
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">{{
              $t('stockCount.itemDetail')
            }}</label>
            <div class="col-md-11">
              <ItemDetail v-model="model" :validate="errors" ref="itemDetail" />
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-1">{{
              $t('stockCount.remark')
            }}</label>
            <div class="col-md-4">
              <textarea
                v-model="model.remarks"
                rows="3"
                class="form-control"
              ></textarea>
            </div>
            <div class="col-md-7">
              <div class="ts-flex ts-justify-end ts-items-end ts-space-x-3">
                <ts-button
                  @click.prevent="$router.push({ name: 'stock-count' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onSave"
                  color="primary"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import ItemDetail from './components/item-details'
import { debounce } from 'lodash'
export default {
  name: 'stockCountCreate',
  components: {
    ItemDetail,
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      search: '',
      model: {
        count_date: moment().format('DD-MM-YYYY'),
        total_amount: 0,
        remarks: null,
        product_detail: [],
      },
    }
  },
  computed: {},
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('stock/stockCount/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-count' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.$refs.itemDetail.productSearch(search)
    }, 500),
  },
}
</script>